import styles from './Rodape.module.css';

function Rodape() {
    return (
        <footer className={styles.rodape}>
            <h2>©2025 Centro Médico Vitrium - Todos Direitos Reservados. <a href="https://www.github.com/GabrielRoOl">Gabriel</a> produziu este site.</h2>
        </footer>
    )
}
export default Rodape;